export default {
	navigation: {
		menuLinks: {
			admin: "Адміністратор",
			runTask: {
				general: 'Запуск завдань',
				singleTask: 'Одиночний',
				multiTask: 'Мультизапуск'
			},
			statusTask: {
				general: 'Статус завдань',
				running: "Запущені",
				finished: "Завершенi",
				deleted: "Видалені"
			},
			commonTask: {
				general: "Загальні задачі",
        processes: "Перегляд процесів",
        services: "Запуск сервісів",
        logs: "Журнали"
			},
			reference: {
				general: "Довідники",
        databases: "Бази даних",
        apps: "Програми",
        servers: "Сервера",
        users: "Користувачі",
        roles: "Ролі",
        appParams: "Параметри програм",
        upgrades: "Оновлення"
			},
			config: {
				general: "Конфігурація",
        configTree: "Конфігурація програм",
        visuals: "Візуалізація",
        configTasks: "Налаштування завдань",
        roleSections: "Бази і ролі",
        sectionTasks: "Завдання і програми",
        roleTasks: "Завдання і ролі"
			},
			cron: {
				general: "Планувальник",
        scheduler: "Редактор",
        history: "Історія"
			}
		},
		headerTitles: {
			singleTask: "Запуск завдань",
      multiTask: "Мультизапуск оновлень",
      running: "Запущені завдання",
      finished: "Завершенi завдання",
      deleted: "Видаленi завдання",
      processes: "Перегляд процесів",
      services: "Запуск сервісів",
      logs: "Журнали",
      databases: "Довідник баз даних",
      apps: "Довідник програм",
      servers: "Довідник серверів",
      users: "Довідник користувачів",
      roles: "Довідник ролей",
      appParams: "Параметри програм",
      upgrades: "Довідник оновлень",
      configTree: "Конфігурація програм",
      visuals: "Візуалізація",
      configTasks: "Налаштування завдань",
      roleSections: "Бази до ролей",
      roleTasks: "Завдання до ролей",
      sectionTasks: "Завдання до програм",
      scheduler: "Редактор планувальника",
      history: "Історія планувальника",
      passwordChange: "Зміна пароля"
		},
		userMenu: {
			version: "Версія web",
      mainServerVersion: "Версія агента",
      userRole: "Роль",
      user: "Користувач",
      serversVersions: "Версії агентів",
      hardwareInfo: "Контроль ресурсів",
      clearLocalStorage: "Очистити пам'ять",
      backup: "Резервна копія",
      passwordChange: "Зміна пароля",
      themeChange: "Зміна теми",
      themeTitle: "Вибір теми",
      themeDark: "Обсідіан",
      themeDesktop: "Класика",
      lastErrors: "Останні помилки",
      exit: "Вихід",
      headerDialog: {
        versions: "Версії",
        generalAgentVersion: "Версія головного агента",
        tinyAgentsVersion: "Версії tiny-агентів",
      },
      headerMessages: {
        plsRefreshPage: "Поновіть сторінку, будь ласка",
        noMistakes: "Помилок немає",
        lastMistakes: "Останні помилки",
      }
		},
		configTaskForm: {
			param: "Параметр",
			name: "Назва",
			lenght: "Довжина",
			cancel: "Скасувати"
		},
		configTree: {
			server: "Сервер",
			servers: "Сервера",
			notExported: "не експортований",
			notExportedPlural: "не експортовані"
		},
		commonTree: {
			saveInFile: "Зберегти в файл",
      showScroll: "Скролл праворуч",
			details: "Детальніше",
			taskNotCompleted: "Завдання не завершено"
		}
	}
};
